/**
 * PDP delivery estimate — client-side date range (scoped init).
 */
(function () {
  'use strict';

  function formatDeliveryDate(date, locale) {
    try {
      return new Intl.DateTimeFormat(locale, {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      }).format(date);
    } catch (err) {
      return new Intl.DateTimeFormat('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
      }).format(date);
    }
  }

  function addDays(baseDate, days) {
    var next = new Date(baseDate.getTime());
    next.setDate(next.getDate() + days);
    return next;
  }

  function initDeliveryEstimate(root) {
    if (!root || root.dataset.pdpDeliveryReady === 'true') return;

    var textEl = root.querySelector('[data-pdp-delivery-text]');
    if (!textEl) return;

    var minDays = parseInt(root.dataset.minDays, 10);
    var maxDays = parseInt(root.dataset.maxDays, 10);
    if (Number.isNaN(minDays)) minDays = 3;
    if (Number.isNaN(maxDays)) maxDays = 6;
    if (minDays > maxDays) {
      var swap = minDays;
      minDays = maxDays;
      maxDays = swap;
    }

    var prefix = root.dataset.prefix || 'Delivers between';
    var locale = root.dataset.locale || document.documentElement.lang || 'en-US';
    var today = new Date();
    today.setHours(12, 0, 0, 0);

    var startDate = addDays(today, minDays);
    var endDate = addDays(today, maxDays);
    var startLabel = formatDeliveryDate(startDate, locale);
    var endLabel = formatDeliveryDate(endDate, locale);

    textEl.textContent = prefix + ' ' + startLabel + ' \u2014 ' + endLabel;
    root.dataset.pdpDeliveryReady = 'true';
  }

  function initScope(scope) {
    (scope || document).querySelectorAll('[data-pdp-delivery-estimate]').forEach(initDeliveryEstimate);
  }

  if (document.readyState !== 'loading') initScope(document);
  else document.addEventListener('DOMContentLoaded', function () { initScope(document); }, { once: true });

  document.addEventListener('shopify:section:load', function (event) {
    initScope(event.target);
  });
})();
